import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { Button, Image } from 'react-bootstrap';

import UserDepartament from '../UserDepartament';

import iconStatusOnline from '../../assets/icon/statusOnline.svg';
import iconStatusAusente from '../../assets/icon/statusAusente.svg';
import iconStatusOcupado from '../../assets/icon/statusOcupado.svg';
import iconLogout from '../../assets/icon/logout.svg';

import { userStatus } from '../../enums/userStatus';
import IconOpcoes from '../../assets/icon/opcoes.svg';

import './userPerfil.css';
import { useUserConfig } from '../../hooks/userConfig';
import { useAuth } from '../../hooks/auth';

const UserPerfil = ({
  setShowUserPerfil,
  showUserPerfil,
  handleChangeStatus,
  handlerLogout,
  nameInitials,
  nameUser,
}: {
  setShowUserPerfil: React.Dispatch<React.SetStateAction<boolean>>;
  showUserPerfil: boolean;
  handleChangeStatus: (newStatus: userStatus) => void;
  handlerLogout: () => void;
  nameInitials: string;
  nameUser: string;
}): JSX.Element => {
  const { userDepartament } = useUserConfig();
  const { corUser } = useAuth();
  return (
    <>
      <div
        className={`${showUserPerfil !== true ? 'd-none' : 'd-block'}`}
        onClick={() => setShowUserPerfil(!showUserPerfil)}
        onKeyDown={() => setShowUserPerfil(!showUserPerfil)}
        role="button"
        style={{
          top: '0',
          left: '0',
          position: 'fixed',
          height: '100vh',
          width: '100vw',
          zIndex: 1,
        }}
        tabIndex={0}
      >
        {' '}
      </div>
      <div
        id="div2"
        className={`transition position-relative ${
          showUserPerfil !== true ? 'hide' : 'show'
        }`}
        style={{
          zIndex: 1100,
          width: '24rem',
          // height: '15rem',
          backgroundColor: '#333333',
          borderRadius: '0.6rem',
        }}
      >
        <div className="d-flex align-items-end" style={{ color: '#fff' }}>
          <span
            className="ps-2 pe-2 "
            style={{
              background: corUser, // 'linear-gradient(135deg, #0094FF 0%, #006DBC 100%) ',
              fontSize: '2.5rem',
              borderStartStartRadius: '0.6rem',
            }}
          >
            {nameInitials}
          </span>
          <div className="d-flex align-items-center justify-content-between w-100 ps-4 border-bottom border-dark border-3 pb-2">
            <span style={{ fontSize: '1.5rem' }}>{nameUser}</span>

            <NavLink to="/Configuracoes">
              <Image
                src={IconOpcoes}
                alt="Configurações"
                className="me-3"
                style={{ width: '1.5rem', height: '1.5rem' }}
              />
            </NavLink>
          </div>
        </div>
        <UserDepartament userDepartament={userDepartament} />
        <div>
          <ul id="options-user-status">
            <li className="option-user-status">
              <input
                type="radio"
                name="category"
                value={userStatus.Online}
                onClick={() => handleChangeStatus(userStatus.Online)}
                data-label="OnLine"
              />
              <Image src={iconStatusOnline} alt="Status Online" />
              <span className="label">online</span>
            </li>

            <li className="option-user-status">
              <input
                type="radio"
                name="category"
                value={userStatus.Ausente}
                onClick={() => handleChangeStatus(userStatus.Ausente)}
                data-label="Ausente"
              />
              <Image src={iconStatusAusente} alt="Status Ausente" />
              <span className="label">ausente</span>
            </li>

            <li className="option-user-status">
              <input
                type="radio"
                name="category"
                value={userStatus.Ocupado}
                onClick={() => handleChangeStatus(userStatus.Ocupado)}
                data-label="Ocupado"
              />
              <Image src={iconStatusOcupado} alt="Status Ocupado" />
              <span className="label">ocupado</span>
            </li>
          </ul>
        </div>
        <div className="d-flex align-items-center justify-content-center">
          <Button
            variant="danger"
            className="mt-2 mb-2 ps-5 pe-5 pt-2 pb-2"
            onClick={handlerLogout}
          >
            <Image
              src={iconLogout}
              alt="Logout"
              className="me-2"
              style={{ width: '1.56rem', height: '1.56rem' }}
            />
            <span style={{ fontSize: '1.2rem' }}>logout</span>
          </Button>
        </div>
      </div>
    </>
  );
};

export default UserPerfil;
